/** Email de pedidos y plazos. El vacío borra el email; un texto a medias no se guarda. */

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SECRET_KEY = /(secret|password|token|api[_-]?key|authorization)/i;

export function orderContactEmailError(value: string): string | null {
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (trimmed.length > 200) return 'El email es demasiado largo';
    if (!EMAIL.test(trimmed)) return 'Email de pedidos no válido';
    return null;
}

export function leadTimeError(value: string): string | null {
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (!/^\d+$/.test(trimmed)) return 'El plazo de preparación tiene que ser un número de días';
    const days = Number(trimmed);
    if (days > 90) return 'El plazo de preparación no puede superar 90 días';
    return null;
}

export function deliveryDaysError(minRaw: string, maxRaw: string): string | null {
    if (!/^\d+$/.test(minRaw.trim())) return 'Días mínimos no válidos';
    if (!/^\d+$/.test(maxRaw.trim())) return 'Días máximos no válidos';
    const min = Number(minRaw.trim());
    const max = Number(maxRaw.trim());
    if (max < min) return 'El máximo debe ser mayor o igual que el mínimo';
    if (max > 90) return 'El máximo no puede superar 90 días';
    return null;
}

export function publicFeedConfig(config: Record<string, unknown> | null | undefined): Record<string, unknown> {
    if (!config) return {};
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(config)) {
        if (SECRET_KEY.test(key)) continue;
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            out[key] = publicFeedConfig(value as Record<string, unknown>);
        } else {
            out[key] = value;
        }
    }
    return out;
}

export const CONNECTOR_LABELS: Record<string, string> = {
    woocommerce_store: 'WooCommerce',
    prestashop: 'PrestaShop',
    file: 'Archivo (CSV o feed)',
};

export const SCHEDULE_LABELS: Record<string, string> = {
    daily: 'Cada día a las 05:00 UTC',
    weekly_monday: 'Los lunes a las 05:00 UTC',
};
